import {
  BaseButton,
  BaseButtonStyle,
  ButtonSize,
} from "components/designV2/buttons/baseButton";
import { ColorV2 } from "config/colors";

/** Props for the primary button component. */
export interface PrimaryButtonProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "type"
> {
  readonly expandIconLabelOnHover?: boolean;
  label?: string;
  iconName?: string;
  size?: ButtonSize;
  type?: "button" | "submit" | "reset";
  styleOverrides?: Partial<BaseButtonStyle>;
  isLoading?: boolean;
}

const PRIMARY_STYLES = {
  backgroundColor: ColorV2.Blue1,
  textColor: ColorV2.White,
  borderColor: "transparent",
  hoverBackgroundColor: ColorV2.Blue2,
  activeBackgroundColor: ColorV2.Blue3,
  disabledBackgroundColor: ColorV2.Blue6,
  disabledTextColor: ColorV2.Blue5,
  disabledBorderColor: "transparent",
  iconColor: ColorV2.White,
  disabledIconColor: ColorV2.Blue5,
};

/** Primary button variant built on top of BaseButton. */
export const PrimaryButton = ({
  label,
  iconName,
  size = "large",
  type = "button",
  disabled,
  expandIconLabelOnHover = true,
  isLoading = false,
  styleOverrides,
  ...rest
}: PrimaryButtonProps): JSX.Element => {
  const resolvedStyles: BaseButtonStyle = {
    ...PRIMARY_STYLES,
    ...styleOverrides,
  };

  return (
    <BaseButton
      label={label}
      iconName={iconName}
      size={size}
      type={type}
      disabled={disabled}
      expandIconLabelOnHover={expandIconLabelOnHover}
      isLoading={isLoading}
      styles={resolvedStyles}
      {...rest}
    />
  );
};
